module.exports = __webpack_public_path__ + "static/lcalottery-1c9c310293e8645d6010d389bf288f8e.png";